import { buildAuthHeaders } from "../../api/client";
import { buildCorrelationHeaders } from "../correlationId";
import { getTelemetryConfig } from "../telemetryConfig";

const queue = [];
let flushTimer = null;
let flushInFlight = false;

function scheduleFlush(delayMs = 1000) {
  if (flushTimer) {
    return;
  }

  flushTimer = window.setTimeout(() => {
    flushTimer = null;
    void flushHttpTelemetryQueue();
  }, delayMs);
}

async function flushHttpTelemetryQueue() {
  if (flushInFlight || queue.length === 0) {
    return;
  }

  flushInFlight = true;
  const batch = queue.splice(0, 25);

  try {
    const { httpEndpoint } = getTelemetryConfig();
    const response = await fetch(httpEndpoint, {
      method: "POST",
      headers: buildAuthHeaders({
        "Content-Type": "application/json",
        ...buildCorrelationHeaders(),
      }),
      body: JSON.stringify({ events: batch }),
      keepalive: true,
    });

    if (!response.ok) {
      throw new Error(`Telemetry ingest failed with status ${response.status}`);
    }
  } catch {
    // Drop failed batches to avoid unbounded retries and telemetry loops.
  } finally {
    flushInFlight = false;
    if (queue.length > 0) {
      scheduleFlush(2000);
    }
  }
}

export function sendHttpTelemetryEvent(event) {
  queue.push(event);
  scheduleFlush();
}

export async function flushTelemetryTransportForTests() {
  if (flushTimer) {
    window.clearTimeout(flushTimer);
    flushTimer = null;
  }
  await flushHttpTelemetryQueue();
}

export function resetHttpTelemetryTransportForTests() {
  queue.length = 0;
  if (flushTimer) {
    window.clearTimeout(flushTimer);
    flushTimer = null;
  }
  flushInFlight = false;
}
